import { useEffect, useState } from "react";
import CustomDrawer from "../../controls/CustomDrawer";
import Select from "../../controls/Select";
import Autocompletesearch from "../../controls/Autocompletesearch";
import ColorPicker from "./ColorPicker";
import Input from "../../controls/Input";
import CustomCheckBox from "../../controls/CustomCheckBox";
import CustomSwitch from "../../controls/CustomSwitch";
import { useSelector } from "react-redux";
import { selectInventoryTransactionType, selectSalesTransactionType } from "../../../redux/slices/transactionTypeSlice";
import { fetchPaymentTypes } from "../../../api/paymentTypesApi";
import { getDashboardSetting, handleAddDashboardSetting } from "../../../api/DashboardApi";
import { toast } from "react-toastify";
import Loading from "../../controls/Loading";
import { selectUser } from "../../../redux/slices/userSlice";

const AddDashboardSetting = ({ onSave, onCancel, closeDrawer }) => {
    const user=useSelector(selectUser);
    const widgets = [
        {
            key: "total_sales",
            name: "Total Sales",
            widget: "WidgetTotalSales",
            title: "Sales",
            description: "Paid amount + Balance amount",
            widgetoptionleftblockcolor: "#00a65a",
            widgetoptionleftblockicon: "fa fa-money"
        },
        {
            key: "total_transactions",
            name: "Total Transactions",
            widget: "WidgetTotalTransactions",
            title: "Transactions",
            description: "",
            widgetoptionleftblockcolor: "#00c0ef",
            widgetoptionleftblockicon: "fa fa-file-o"
        },
        {
            key: "total_customers",
            name: "Total Customers",
            widget: "WidgetTotalCustomers",
            title: "Customers",
            description: "",
            widgetoptionleftblockcolor: "#f39c12",
            widgetoptionleftblockicon: "fa fa-users"
        },
        {
            key: "total_expense",
            name: "Total Expense",
            widget: "WidgetTotalExpenses",
            title: "Expense",
            description: "",
            widgetoptionleftblockcolor: "#dd4b39",
            widgetoptionleftblockicon: "fa fa-cart-plus"
        },
        {
            key: "total_credit_sale",
            name: "Total Credit Sale",
            widget: "WidgetTotalCreditSales",
            title: "Credit Sale",
            description: "",
            widgetoptionleftblockcolor: "#00a65a",
            widgetoptionleftblockicon: "fa fa-inr"
        },
        {
            key: "total_received",
            name: "Total Received",
            widget: "WidgetTotalReceived",
            title: "Received",
            description: "",
            widgetoptionleftblockcolor: "#00a65a",
            widgetoptionleftblockicon: "fa fa-inr"
        },
        {
            key: "store_comparison",
            name: "Store Comparison",
            widget: "WidgetTotalStoresSales",
            title: "Store Comparison",
            description: ""
        },
        {
            key: "payment_mode_comparison",
            name: "Payment Mode Comparison",
            widget: "WidgetPaymentDashboard",
            title: "Payment Mode",
            description: ""
        },
        {
            key: "last_12_month_sales",
            name: "Last 12 Month Sales",
            widget: "WidgetLast12MonthsSales",
            title: "Last 12 Month Sales",
            description: ""
        },
        {
            key: "quarterly_sales",
            name: "Quarterly Sales",
            widget: "WidgetQuarterSales",
            title: "Quarterly Sales",
            description: ""
        },
        {
            key: "category_top_x",
            name: "Category Top X",
            widget: "WidgetTopCategories",
            title: "Category",
            description: ""
        },
        {
            key: "sub_category_top_x",
            name: "Sub Cateogry Top X",
            widget: "WidgetTopSubCategories",
            title: "Sub Cateogry",
            description: ""
        },
        {
            key: "brand_top_x",
            name: "Brand Top X",
            widget: "WidgetTopBrands",
            title: "Brand",
            description: ""
        },
        {
            key: "products_top_x",
            name: "Products Top X",
            widget: "WidgetTopProducts",
            title: "Top Products",
            description: ""
        },
        {
            key: "top_product_type",
            name: "Top X Product Type",
            widget: "WidgetTopProductTypes",
            title: "Top Product Type",
            description: ""
        },
        {
            key: "customers_analysis",
            name: "Customers Analysis",
            widget: "WidgetCustomerAnalysis",
            title: "Customers",
            description: ""
        },
        {
            key: "employees_top_x",
            name: "Employees Top X",
            widget: "WidgetTopEmployees",
            title: "Employees",
            description: ""
        },
        {
            key: "specific_product_type",
            name: "Specific Product Type",
            widget: "WidgetTopProductType",
            title: "",
            description: ""
        },
        {
            key: "specific_payment_mode",
            name: "Specific Payment Mode",
            widget: "WidgetSpecificPaymentSales",
            title: "",
            description: ""
        },
        {
            key: "last_12_month_sales_vs_purchase",
            name: "Last 12 Month Sales vs Purchase",
            widget: "WidgetLast12MonthsSalesVsPurchase",
            title: "Last 12 Months Sales vs Purchase",
            description: ""
        },
        {
            key: "store_wise_sales_vs_purchase",
            name: "Store Wise - Sales vs Purchase",
            widget: "WidgetSalesVsPurchaseStoreWise",
            title: "",
            description: ""
        }
    ];
    const [loading,setLoading]=useState(false);
    const [widgetError, setWidgetError] = useState("");
    const [selectedWidget, setSelectedWidget] = useState({});
    const [color, setColor] = useState("");
    const [title, setTitle] = useState("");
    const [titleError, setTitleError] = useState("");
    const [widgetOptionIncludeBalance, setWidgetOptionIncludeBalance] = useState(false);
    const [widgetOptionIncludeTransactionTypes, setWidgetOptionIncludeTransactionTypes] = useState(false);
    const salesTransactionTypes = useSelector(selectSalesTransactionType);
    const inventoryTransactionTypes = useSelector(selectInventoryTransactionType);
    const [widgetOptionTransactionTypeIDs, setWidgetOptionTransactionTypeIDs] = useState([]);
    const [widgetOptionPaymentMode, setWidgetOptionPaymentMode] = useState("");
    const [widgetOptionPaymentModeID, setWidgetOptionPaymentModeID] = useState("");
    const [paymentModeError, setPaymentModeError] = useState("");
    const [paymentTypes, setPaymentTypes] = useState([]);

    const [widgetOptionTopX, setWidgetOptionTopX] = useState(5);
    const [widgetOptionProductType, setWidgetOptionProductType] = useState("");
    const [widgetOptionAmtOrQty, setWidgetOptionAmtOrQty] = useState("");
    const [colorError,setColorError]=useState("");

    const fetchPaymentData = async () => {
        try {
            const response = await fetchPaymentTypes();
            const filteredData = response.paymentTypes.filter((payment) => payment.ShowInSales && !payment.IsDeleted);
            setPaymentTypes(filteredData);
        } catch (err) {
            console.error("Error fetching payment type:", err);
        }
    };

    useEffect(() => {
        fetchPaymentData();
    }, [])

    const onTransactionTypeSelected = (key, checked) => {
        setWidgetOptionTransactionTypeIDs(prev => {
            if (checked) {
                // add if not already present
                return prev.includes(key) ? prev : [...prev, key];
            } else {
                // remove if unchecked
                return prev.filter(id => id !== key);
            }
        });
    };

    const productTypeOptions = [
        { label: "Goods for Sale", value: "goods for sale" },
        { label: "Services", value: "services" },
        { label: "Wallet Recharge", value: "wallet recharge" },
        { label: "Packages", value: "packages" }
    ];

    const widgetLabelMap = {
        WidgetCustomersTop: "customers",
        WidgetTopEmployees: "employees",
        WidgetTopCategories: "categories",
        WidgetTopSubCategories: "sub categories",
        WidgetTopBrands: "brands",
    };
  const onAddWidget=async()=>
    {
        let titleError = ""
        let colorError=""
        let iconError=""
        let paymentModeError=""
        if(title.trim()==="")
        {
            titleError = "Plase provide title"
        }
        if(selectedWidget?.widget ==="WidgetTotalSales"
                                           || selectedWidget?.widget ==="WidgetTotalTransactions" 
                                          || selectedWidget?.widget ==="WidgetTotalCustomers" 
                                       || selectedWidget?.widget ==="WidgetTotalExpenses" 
                                          || selectedWidget?.widget ==="WidgetTotalCreditSales" 
                                           || selectedWidget?.widget ==="WidgetTotalReceived" 
                                         || selectedWidget?.widget ==="WidgetTotalCreditReceived"
                                        || selectedWidget?.widget === "WidgetSpecificPaymentSales")
        {
            if(color==="")
            {
                colorError="Please select color"
            }
           
        }
        if(selectedWidget?.widget === "WidgetSpecificPaymentSales" && widgetOptionPaymentMode.trim()==="")
        {
            paymentModeError="Please select payment mode"
        }
        if(titleError.trim()!=="" || colorError.trim()!==""  || paymentModeError.trim()!=="")
        {
            setTitleError(titleError);
            setColorError(colorError);
            setPaymentModeError(paymentModeError);
            return 
        }
        let widget = {Name:selectedWidget.name,
        Title: title,
        Widget:selectedWidget?.widget,
        WidgetOptionAmtOrQty:widgetOptionAmtOrQty,
        WidgetOptionTopX: widgetOptionTopX,
        WidgetOptionProductType: widgetOptionProductType,
        WidgetOptionPaymentMode: widgetOptionPaymentMode,
        WidgetOptionPaymentModeID: widgetOptionPaymentModeID,
        WidgetOptionIncludeBalance:widgetOptionIncludeBalance,
        WidgetOptionIncludeTransactionTypes:widgetOptionIncludeTransactionTypes,
        WidgetOptionTransactionTypeIDs: widgetOptionTransactionTypeIDs,

        WidgetOptionLeftBlockColor:color,
        WidgetOptionLeftBlockIcon:"",
        }
        let infoText = ""
        if(selectedWidget?.widget === "WidgetTopCategories" || 
      selectedWidget?.widget=== "WidgetTopSubCategories" ||
       selectedWidget?.widget === "WidgetTopBrands" ||
        selectedWidget?.widget=== "WidgetCustomersTop" || 
     selectedWidget?.widget === "WidgetTopEmployees" ||
      selectedWidget?.widget === "WidgetSpecificProductType")
        {
            infoText = "Show top " + widgetOptionTopX + " by " + widgetOptionAmtOrQty
        }
        widget.InfoText = infoText
     setLoading(true);
        try{

 const response=await getDashboardSetting();
         console.log("response",response);
         if(response.code=="0"){
                 let selectedWidgets = response?.dashboardSetting?.Widgets || [];
        selectedWidgets.push(widget)
                let dashboardSetting = {
            UID:user.UID,
            RegistrationID: user.RegistrationID,
            Widgets: selectedWidgets
        }

        const dashboardSettingResponse=await handleAddDashboardSetting(dashboardSetting);
        if(dashboardSettingResponse?.code=="0"){
            toast.success("Setting saved !");
            onSave();
        }
        else{
            toast.error(dashboardSettingResponse?.message || "Failed to saved!");
        }


         }
         else{
         toast.error(response?.message || "Failed to saved!");
         }
        }
        catch(error){
  toast.error(error?.message || "Failed to saved!");
        }
        finally{
            setLoading(false);
        }
    }
  

    return (
        <CustomDrawer
            buttons={[
                { Label: "Cancel", Type: "secondary", Icon: "roundedRemove" },
                { Label: "Save", Type: "primary", Icon: "save" },

            ]}
            onButtonClick={(label) => {
                if (label === "Save") {
                    onAddWidget();
                } else if (label === "Cancel") {
                    onCancel();

                }
            }}
            setDrawer={closeDrawer}
            title={"New Widget"}
            drawerType="medium"
        >{loading && <Loading/>}
          {!loading &&  <div className="grid gap-5">

                <Autocompletesearch
                    isMandatory={true}
                    value={selectedWidget?.name}
                    label="Select Widget"
                    data={widgets}
                    filterKey={["name"]}
                    defaultDataCount={26}
                    onChange={(value) => {
                        if (value !== "") {
                            setWidgetError("");
                        }
                        setSelectedWidget({});
                    }}
                    onSelect={(item) => {
                        setSelectedWidget(item);
                        setTitle(item?.title);
                        setColor(item?.widgetoptionleftblockcolor);
                    }}
                    placeholder="Search widget"
                    showsearch={false}
                    renderSuggestion={(item, index) => (
                        <div>
                            <p className="">{item.name}</p>
                        </div>
                    )}
                    errorMessage={widgetError}
                />


                <Input
                    label={"Title"}
                    value={title}
                    onChange={(e) => { setTitle(e.target.value), setTitleError("") }}
                    errorMessage={titleError} />


                {(selectedWidget?.widget === "WidgetTotalSales") &&
                    <>
                        <CustomSwitch
                            formlabel="Include balance amount"
                            checked={widgetOptionIncludeBalance}
                            onChange={(checked) => setWidgetOptionIncludeBalance(checked)}
                        />
                        <CustomSwitch
                            formlabel="Include specific Transaction Types"
                            checked={widgetOptionIncludeTransactionTypes}
                            onChange={(checked) => setWidgetOptionIncludeTransactionTypes(checked)}
                        />



                        {widgetOptionIncludeTransactionTypes &&
                            <div>
                                <label>Select Transaction Types</label>
                                {salesTransactionTypes
                                    .filter(f => !f.IsDeleted)
                                    .map((m) => (
                                        <CustomCheckBox
                                            key={m.key}
                                            label={m.TransactionType}
                                            checked={widgetOptionTransactionTypeIDs.includes(m.key)}
                                            onChange={(checked) => onTransactionTypeSelected(m.key, checked)}
                                        />
                                    ))}

                            </div>}


                    </>}

                {selectedWidget?.widget == "WidgetSpecificPaymentSales" &&
                    <Select
                        label="Please select payment mode"
                        value={widgetOptionPaymentModeID}
                        onChange={(e) => setWidgetOptionPaymentModeID(e.target.value)}
                        options={paymentTypes.map(payment => ({
                            label: payment.PaymentType,
                            value: payment.key
                        }))}
                    />}

                {(selectedWidget?.widget === "WidgetTopCategories" ||
                    selectedWidget?.widget === "WidgetTopSubCategories" ||
                    selectedWidget?.widget === "WidgetTopBrands" ||
                    selectedWidget?.widget === "WidgetCustomersTop" ||
                    selectedWidget?.widget === "WidgetTopEmployees" ||
                    selectedWidget?.widget === "WidgetTopProductType") &&
                    <div>
                        <Input type={"number"}
                            label={"Show top"}
                            value={widgetOptionTopX}
                            onChange={(e) => { e.target.value }} />

                        {selectedWidget === "WidgetTopProductType" &&
                            <Select
                                label="Please select product type"
                                value={widgetOptionProductType}
                                onChange={(e) => setWidgetOptionProductType(e.target.value)}
                                options={productTypeOptions}
                            />}

                        <Select
                            label={`${widgetLabelMap[selectedWidget?.widget] || ""} by`}
                            value={widgetOptionAmtOrQty}
                            options={[{ label: "sales amount", value: "amount" },
                            { label: "sales qty", value: "qty" }]}
                            onChange={(e)=>{setWidgetOptionAmtOrQty(e.target.value)}}
                        />

                    </div>}



                <ColorPicker value={color} onChange={(color) => { setColor(color) }} />
            </div>}
        </CustomDrawer >
    )
}
export default AddDashboardSetting;